<template>
  <InteractionStep
                   :disabledNext="!type"
                   :pendingNext="pending"
                   @next="onNext">
    <template v-slot:content>
      <div class="step-type">
        <img src="../../../assets/img/svg/step-type-ico.svg" alt="type" class="step-type__img">

        <BaseRadioList  :value="type"
                        :options="list"
                        textKey="title"
                        columns
                        @input="onTypeInput"
                        class="step-type__list"/>
      </div>
    </template>
  </InteractionStep>
</template>

<script>
  import {http} from '@/axios'
  import {
    EMPLOYMENT_TYPE_WORK_VISA,
    EMPLOYMENT_TYPE_SEASON_VISA,
    EMPLOYMENT_TYPE_BIOMETRIC,
    EMPLOYMENT_TYPE_CUSTOM
  } from '@/constants/interaction'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import InteractionStep from '../InteractionStep'
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    mixins: [interactionStepMixin],
    data() {
      return {
        type: null,
        error: null,
        pending: false,
        list: [
          {
            id: EMPLOYMENT_TYPE_WORK_VISA,
            title: this.$tInteraction('On a work visa')
          },
          {
            id: EMPLOYMENT_TYPE_SEASON_VISA,
            title: this.$tInteraction('On a seasonal visa')
          },
          {
            id: EMPLOYMENT_TYPE_BIOMETRIC,
            title: this.$tInteraction('On biometrics')
          },
          {
            id: EMPLOYMENT_TYPE_CUSTOM,
            title: this.$tInteraction('Individual mode')
          }
        ]
      }
    },
    components: {
      InteractionStep
    },
    computed: {
      ...mapState('interaction', {
        statusesGroups: (state) => {
          return state.stepData.data.statuses
        }
      }),
    },
    methods: {
      ...mapMutations('interaction', [
        'setProperty'
      ]),
      ...mapActions('interaction', [
        'loadInteraction'
      ]),
      onTypeInput(type) {
        this.type = type
        this.setProperty(['statuses', this.statusesGroups[type.id]])
      },
      onNext() {
        this.pending = true

        const sendData = {
          interaction_id: this.$route.params.id,
          employment_type: this.type.id
        }

        http.post('api/new-interaction/set-employment-type', sendData).then(async () => {
          await this.loadInteraction()
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pending = false
        })
      }
    }
  }
</script>

<style>

</style>
